export default __webpack_public_path__ + "static/media/vuesax-linear-profile.971f678f.svg";